
import React from 'react';
import { CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const SubmissionFormFooter: React.FC = () => {
  return (
    <CardFooter className="flex flex-col space-y-4">
      <Button 
        type="submit" 
        className="w-full"
      >
        Submit Terrace
      </Button>
      
      <div className="text-xs text-muted-foreground text-center">
        <p>All submissions are reviewed by our team before being published.</p>
        <p>By submitting, you confirm this information is accurate to the best of your knowledge.</p>
      </div>
    </CardFooter>
  );
};

export default SubmissionFormFooter;
